import { FC } from 'react'

import { Card } from '@joor/design-system'

import { Flex } from 'styles/components'
import { getLinkToOrder } from 'utils/links'
import { useUserAnalytics } from 'utils/sdks/userAnalytics'

import { Order } from '../../types'
import { CardItemHeader, CardItemInfo } from './styles'

const EMPTY_PARAM_CHAR = '—'

const OrderDetails: FC<{ order: Order }> = ({ order }) => {
  const { trackEvent } = useUserAnalytics()

  return (
    <Card
      title="Order Details"
      actionButtonLabel="View"
      onClickActionButton={() => {
        trackEvent('JP_OrderDetails')
        window.open(getLinkToOrder(order))
      }}
    >
      <Flex flexDirection="column" rowGap="20px">
        <div>
          <CardItemHeader variant="order">Linesheets</CardItemHeader>
          <CardItemInfo>{order.collectionNames}</CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Season</CardItemHeader>
          <CardItemInfo>
            {order?.seasonYear?.season?.name ?? EMPTY_PARAM_CHAR}
          </CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Year</CardItemHeader>
          <CardItemInfo>
            {order?.seasonYear?.year ?? EMPTY_PARAM_CHAR}
          </CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Door</CardItemHeader>
          <CardItemInfo>{order?.door?.name ?? EMPTY_PARAM_CHAR}</CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Warehouse</CardItemHeader>
          <CardItemInfo>
            {order?.warehouse?.name ?? EMPTY_PARAM_CHAR}
          </CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Order Delivery Window</CardItemHeader>
          <CardItemInfo>{order?.deliveryWindow}</CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">
            Shipping Delivery Window
          </CardItemHeader>
          <CardItemInfo>{order?.deliveryWindow}</CardItemInfo>
        </div>
        <div>
          <CardItemHeader variant="order">Payment Method</CardItemHeader>
          <CardItemInfo>{order?.paymentMethod?.paymentName}</CardItemInfo>
        </div>
      </Flex>
    </Card>
  )
}
export default OrderDetails
